import { render, staticRenderFns } from "./PlanList.vue?vue&type=template&id=24d8a896&"
import script from "./PlanList.vue?vue&type=script&lang=ts&"
export * from "./PlanList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports